import { render, staticRenderFns } from "./delivery-plan-detail.vue?vue&type=template&id=5d238db2&scoped=true&"
import script from "./delivery-plan-detail.vue?vue&type=script&lang=js&"
export * from "./delivery-plan-detail.vue?vue&type=script&lang=js&"
import style0 from "./delivery-plan-detail.vue?vue&type=style&index=0&id=5d238db2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d238db2",
  null
  
)

export default component.exports